import React from "react";
import { SSH_FeatureHandler } from "../../../helpers/FeatureHandler.helper";
import V1 from "./v1/DepartmentsListV1.component";
import V2 from "./v2/DepartmentsListV2.component";

const featureName = "blockDepartmentList";
const versions = {
    v1: V1,
    v2: V2,
};

// eslint-disable-next-line unused-imports/no-unused-vars
export const SSH_Departments = React.forwardRef(({ version, ...props }: any, ref: any) => (
    <SSH_FeatureHandler
        featureName={featureName}
        featureVersions={versions}
        version={version}
        {...props}
    />
));

SSH_Departments.displayName = "SSH_Departments";
